import { Box, Typography } from "@material-ui/core";
import { Icon, IconName } from "halifax";
import React, { useState } from "react";

interface ILocationMarker {
  lat: number;
  lng: number;
  zIndex: number;
  label: string;
}

export const LocationMarker = ({ label }: ILocationMarker) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Box position="relative">
      <Icon name={IconName.MapPin} />

      {isOpen && (
        <Box
          padding="7px"
          position="absolute"
          top="130%"
          left="50%"
          display="flex"
          alignItems="center"
          width="max-content"
          justifyContent="center"
          style={{
            gap: "5px",
            backgroundColor: "var(--white)",
            borderRadius: "4px",
            border: "1px solid var(--grey-11)",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Typography style={{ fontSize: "12px", fontWeight: "600" }}>
            {label}
          </Typography>
          <Icon
            name={IconName.CloseXCircle2}
            width="10px"
            height="10px"
            onClick={() => setIsOpen(false)}
            style={{
              cursor: "pointer",
            }}
          />
        </Box>
      )}
    </Box>
  );
};
